// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"551":"support","997":"styleguide"}[chunkId] || chunkId) + "." + {"551":"b549239e","787":"81ec95b5","997":"73f00bdf"}[chunkId] + ".chunk.js";
};